(function(){
  'use strict';

  function q(sel, el){ return (el||document).querySelector(sel); }
  function qa(sel, el){ return Array.prototype.slice.call((el||document).querySelectorAll(sel)); }

  function initADT(root){
    var tabsWrap = q('[data-adt-tabs]', root);
    var panelsWrap = q('[data-adt-panels]', root);
    if(!tabsWrap || !panelsWrap) return;
    var tabs = qa('.adt__tab', tabsWrap);
    if(!tabs.length) return;
    var panels = qa('.adt__panel', panelsWrap);
    var pill = q('.adt__pill', tabsWrap);
    var tri = q('.adt__triangle', root.querySelector('[data-adt-panels]'));
    var reduceSetting = root.getAttribute('data-reduce-motion') === 'true';
    var reduceMedia = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reduce = reduceSetting && reduceMedia; // only disable animations if both are true

    var index = 0;
    tabs.forEach(function(btn,i){ if(btn.getAttribute('aria-selected') === 'true'){ index = i; } });

    function setSelected(i, focus){
      if(i<0||i>=tabs.length) return;
      // Measure outgoing/next heights and animate container height reliably
      var mediaReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var reduceHeight = reduceSetting && mediaReduce;
      var currentPanel = panels[index];
      var nextPanel = panels[i];

      if(panelsWrap){
        // 1) Lock starting height (from current panel)
        var startHeight = 0;
        if(currentPanel && !currentPanel.hasAttribute('hidden')){
          startHeight = currentPanel.offsetHeight;
        } else if(currentPanel){
          currentPanel.removeAttribute('hidden');
          startHeight = currentPanel.offsetHeight;
          currentPanel.setAttribute('hidden','');
        }
        panelsWrap.style.height = startHeight + 'px';
        // Force reflow to ensure start height is committed
        void panelsWrap.offsetHeight;

        // 2) Reveal next panel (opacity 0) to measure target height
        nextPanel.removeAttribute('hidden');
        nextPanel.style.opacity = '0';
        var targetHeight = nextPanel.offsetHeight;

        // 3) Animate container height to target
        if(!reduceHeight){
          requestAnimationFrame(function(){ panelsWrap.style.height = targetHeight + 'px'; });
        } else {
          panelsWrap.style.height = targetHeight + 'px';
        }
      }
      tabs.forEach(function(btn,bi){
        var sel = bi===i;
        btn.setAttribute('aria-selected', sel ? 'true' : 'false');
        btn.tabIndex = sel ? 0 : -1;
        if(focus && sel) btn.focus({preventScroll:true});
      });
      panels.forEach(function(p,pi){
        if(pi===i){
          p.removeAttribute('hidden');
          requestAnimationFrame(function(){ p.style.opacity = '1'; });
        } else {
          p.style.opacity = '0';
          p.setAttribute('hidden','');
        }
      });
      index = i;
      measureAndMove();
      // Equalize benefit card heights for the active panel after layout
      scheduleEqualize();
      if(panelsWrap){
        // After transition, clear inline height to allow natural sizing
        var onEnd = function(e){
          if(e.propertyName === 'height'){
            panelsWrap.removeEventListener('transitionend', onEnd);
            panelsWrap.style.height = '';
          }
        };
        panelsWrap.addEventListener('transitionend', onEnd);
      }
    }

    // Equalize heights of benefit cards within the active panel
    var eqResizeTimer;
    function equalizeBenefitCards(panel){
      if(!panel) return;
      var cards = qa('.adt__benefit-card', panel);
      if(!cards.length) return;
      // Reset heights to natural, measure, then set to max
      cards.forEach(function(c){ c.style.height = ''; });
      var maxH = 0;
      cards.forEach(function(c){ var h = c.offsetHeight; if(h > maxH) maxH = h; });
      if(maxH > 0){ cards.forEach(function(c){ c.style.height = maxH + 'px'; }); }
      // After height adjustments, ensure panelsWrap can accommodate the new tallest content
      if(panelsWrap){
        // Temporarily set height to auto to measure, then clear to allow CSS transition logic
        var previous = panelsWrap.style.height;
        panelsWrap.style.height = 'auto';
        var h = panelsWrap.offsetHeight; // force read
        if(previous){ panelsWrap.style.height = previous; }
        // Next frame clear to natural height to avoid clipping
        requestAnimationFrame(function(){ panelsWrap.style.height = ''; });
      }
    }

    function equalizeInCurrentPanel(){
      var active = panels[index]; if(!active || active.hasAttribute('hidden')) return;
      equalizeBenefitCards(active);
    }

    function scheduleEqualize(){
      requestAnimationFrame(equalizeInCurrentPanel);
    }

    function measureAndMove(){
      var btn = tabs[index]; if(!btn||!pill||!tri) return;
      var wrapRect = tabsWrap.getBoundingClientRect();
      var r = btn.getBoundingClientRect();
      var x = r.left - wrapRect.left + tabsWrap.scrollLeft;
      var w = r.width;
      if(reduce){ pill.style.transition = 'none'; tri.style.transition = 'none'; }
      pill.style.transform = 'translateX('+x+'px)';
      pill.style.width = w+'px';
      // Triangle sits at top of panels; align horizontally to pill centre
      tri.style.transform = 'translateX('+(x + w/2 - 8)+'px)';
    }

    function onKey(e){
      if(e.key==='ArrowRight'){ e.preventDefault(); setSelected(Math.min(index+1,tabs.length-1), true); }
      else if(e.key==='ArrowLeft'){ e.preventDefault(); setSelected(Math.max(index-1,0), true); }
      else if(e.key==='Home'){ e.preventDefault(); setSelected(0, true); }
      else if(e.key==='End'){ e.preventDefault(); setSelected(tabs.length-1, true); }
    }

    tabsWrap.addEventListener('click', function(e){
      var btn = e.target.closest('.adt__tab'); if(!btn) return;
      setSelected(parseInt(btn.getAttribute('data-tab-index'),10)||0, false);
    });
    tabsWrap.addEventListener('keydown', onKey);

    var ro;
    if('ResizeObserver' in window){
      ro = new ResizeObserver(function(){ requestAnimationFrame(measureAndMove); });
      ro.observe(tabsWrap);
    }
    window.addEventListener('resize', function(){
      requestAnimationFrame(measureAndMove);
      clearTimeout(eqResizeTimer);
      eqResizeTimer = setTimeout(scheduleEqualize, 100);
    });
    document.fonts && document.fonts.ready && document.fonts.ready.then(function(){
      measureAndMove();
      scheduleEqualize();
    });

    // Dropdowns
    qa('[data-adt-dropdown]', root).forEach(function(btn){
      var panel = btn.nextElementSibling;
      if(!panel) return;
      btn.addEventListener('click', function(){
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var reduceLocal = window.matchMedia('(prefers-reduced-motion: reduce)').matches || reduce;
        if(expanded){
          btn.setAttribute('aria-expanded','false');
          if(reduceLocal){ panel.hidden = true; return; }
          var cur = panel.scrollHeight; panel.style.height = cur+'px'; panel.hidden = false; requestAnimationFrame(function(){ panel.style.height = '0px'; });
          panel.addEventListener('transitionend', function te(){ panel.removeEventListener('transitionend', te); panel.hidden = true; panel.style.height=''; }, { once:true });
        } else {
          btn.setAttribute('aria-expanded','true');
          panel.hidden = false; var h; panel.style.height = 'auto'; h = panel.scrollHeight; panel.style.height = '0px'; requestAnimationFrame(function(){ panel.style.height = h+'px'; });
          panel.addEventListener('transitionend', function te(){ panel.removeEventListener('transitionend', te); panel.style.height=''; }, { once:true });
        }
      });
    });

    // Initial
    requestAnimationFrame(function(){ setSelected(index,false); });
  }

  function initAll(){ qa('.adt').forEach(initADT); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();


